
export class DateLibreGroup {

  public intitule: string;
  public dateHeureLibre: string;

  constructor() {
    this.intitule = '';
    this.dateHeureLibre = '';
  }
}
